/*!

=========================================================
* Argon Dashboard React - v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Index from "views/Index";
// import Profile from "views/examples/Profile";
// import Maps from "views/examples/Maps";
// import Register from "views/pages/Register";
// import Login from "views/pages/Login";
// import Tables from "views/examples/Tables";
// import Icons from "views/examples/Icons";
import Profile from "views/pages/Profile";
import ManageUsers from "views/ManagePages/ManageUsers";
import Community from "views/pages/Community"
import ManageCommunity from "views/ManagePages/ManageCommunity";
import WorkActivities from "views/pages/WorkActivities";
import ManageCoachTutorAvailability from "views/ManagePages/ManageCoachTutorAvailability";
import ManageTutorRequests from "views/ManagePages/ManageTutorRequests";
import ManageTpcCourses from "./views/ManagePages/ManageTpcCourses";
import ManageTpcCoursesLessons from "./views/ManagePages/ManageTpcCoursesLessons";
import ManageDatCourses from "./views/ManagePages/ManageDatCourses";
import PrepTalk from "./views/pages/PrepTalk";
import Settings from "views/pages/Settings";

// Question Bank pages
import DashboardPage from "views/ManagePages/QuestionBank/DashboardPage";
import ManageSubjectsUnitsPage from "views/ManagePages/QuestionBank/ManageSubjectsUnitsPage";
import CreateQuestionPage from "views/ManagePages/QuestionBank/CreateQuestionPage";
import AIGenerationPage from "views/ManagePages/QuestionBank/AIGenerationPage";
import BulkUploadPage from "views/ManagePages/QuestionBank/BulkUploadPage";
import FeedbackPage from "views/ManagePages/QuestionBank/FeedbackPage";
import ManageFullLengthExamsPage from "views/ManagePages/QuestionBank/ManageFullLengthExamsPage";
import CreateFullLengthExamPage from "views/ManagePages/QuestionBank/CreateFullLengthExamPage";
import FullLengthExamAnalyticsPage from "views/ManagePages/QuestionBank/FullLengthExamAnalyticsPage";
import ManagePassagesPage from "views/ManagePages/QuestionBank/ManagePassagesPage";

var routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-primary",
    component: Index,
    layout: "/admin"
  },
  {
    path: "/manage-users",
    name: "Manage Users",
    icon: "fas fa-user text-info",
    component: ManageUsers,
    layout: "/admin"
  },
    {
    path: "/manage-community",
    name: "Manage Community",
    icon: "fas fa-users text-warning",
    component: Community,
    layout: "/admin",
    items:[
      {
        path: "/community-page",
        name: "Community Page",
       icon: "fas fa-users text-warning",
        component: Community,
        layout: "/admin"
      },
       {
      path: "/community-settings",
      name: "Community Settings ",
      icon: "fas fa-cog text-green",
      component: ManageCommunity,
      layout: "/admin"
    },
    ]
  },
  // {
  //   path: "/maps",
  //   name: "Maps",
  //   icon: "ni ni-pin-3 text-orange",
  //   component: Maps,
  //   layout: "/admin"
  // },
  // {
  //   path: "/user-profile",
  //   name: "User Profile",
  //   icon: "ni ni-single-02 text-yellow",
  //   component: Profile,
  //   layout: "/admin"
  // },
  // {
  //   path: "/tables",
  //   name: "Secondary Essays",
  //   icon: "ni ni-bullet-list-67 text-red",
  //   component: Tables,
  //   layout: "/admin"
  // },
  {
    path: "/manage-coach-tutor-availability",
    name: "Manage Coach Tutor Availability",
    icon: "fas fa-calendar-alt text-pink",
    component: ManageCoachTutorAvailability,
    layout: "/admin"
  },

  {
    path: "/manage-tutor-requests",
    name: "Manage Tutor Requests",
    icon: "fas fa-calendar-alt text-yellow",
    component: ManageTutorRequests,
    layout: "/admin"
  },
  {
    path: "/community-page",
    name: "Community Page",
     icon: "fas fa-users text-warning",
    component: Community,
    layout: "/admin"
  },
    {
      path: "/community-settings",
      name: "Community Settings",
      icon: "fas fa-cog text-green",
      component: ManageCommunity,
      layout: "/admin"
    },
  
  {
    path: "/manage-tpc-courses",
    name: "Manage TPC Courses",
    icon: "ni ni-books text-primary",
    component: ManageTpcCourses,
    layout: "/admin"
  },

  {
    path: "/manage-dat-courses",
    name: "Manage DAT Courses",
    icon: "ni ni-books text-danger",
    component: ManageDatCourses,
    layout: "/admin"
  },

  {
    path: "/my-profile",
    name: "My Profile",
    icon: "ni ni-circle-08 text-pink",
    component: Profile,
    layout: "/admin"
  },
  {
    path: "/settings",
    name: "Settings",
    icon: "fas fa-cog text-gray",
    component: Settings,
    layout: "/admin"
  },
  {
    path: "/prep-talk",
    name: "PrepTalk",
    icon: "fas fa-envelope text-info",
    component: PrepTalk,
    layout: "/admin"
  },
  // Individual Question Bank sub-routes (for routing purposes)
  {
    path: "/question-bank/dashboard",
    name: "Dashboard",
    icon: "fas fa-chart-pie text-purple",
    component: DashboardPage,
    layout: "/admin",
    invisible: true
  },
  {
    path: "/question-bank/subjects-units",
    name: "Subjects & Units",
    icon: "fas fa-book text-purple",
    component: ManageSubjectsUnitsPage,
    layout: "/admin",
    invisible: true
  },
  {
    path: "/question-bank/create-question",
    name: "Create Question",
    icon: "fas fa-plus-circle text-purple",
    component: CreateQuestionPage,
    layout: "/admin",
    invisible: true
  },
  {
    path: "/question-bank/ai-generation",
    name: "AI Generation",
    icon: "fas fa-magic text-purple",
    component: AIGenerationPage,
    layout: "/admin",
    invisible: true
  },
  {
    path: "/question-bank/bulk-upload",
    name: "Bulk Upload",
    icon: "fas fa-file-upload text-purple",
    component: BulkUploadPage,
    layout: "/admin",
    invisible: true
  },
  {
    path: "/question-bank/feedback",
    name: "Feedback",
    icon: "fas fa-comment-alt text-purple",
    component: FeedbackPage,
    layout: "/admin",
    invisible: true
  },
  {
    path: "/question-bank/passages",
    name: "Manage Passages",
    icon: "fas fa-file-alt text-purple",
    component: ManagePassagesPage,
    layout: "/admin",
    invisible: true
  },
  {
    path: "/question-bank/full-length-exams/create",
    name: "Create Full-Length Exam",
    icon: "fas fa-file-alt text-purple",
    component: CreateFullLengthExamPage,
    layout: "/admin",
    invisible: true
  },
  {
    path: "/question-bank/full-length-exam-analytics",
    name: "Exam Analytics",
    icon: "fas fa-chart-bar text-purple",
    component: FullLengthExamAnalyticsPage,
    layout: "/admin",
    invisible: true
  },
  {
    path: "/question-bank/full-length-exams",
    name: "Full-Length Exams",
    icon: "fas fa-file-alt text-purple",
    component: ManageFullLengthExamsPage,
    layout: "/admin",
    invisible: true
  },
  // Main Question Bank menu item with sub-nav items
  {
    path: "/question-bank",
    name: "Manage Question Bank",
    icon: "fas fa-question-circle text-purple",
    component: DashboardPage,
    layout: "/admin",
    items: [
      {
        path: "/question-bank/dashboard",
        name: "Dashboard",
        icon: "fas fa-chart-pie text-purple",
        component: DashboardPage,
        layout: "/admin"
      },
      {
        path: "/question-bank/subjects-units",
        name: "Subjects & Units",
        icon: "fas fa-book text-purple",
        component: ManageSubjectsUnitsPage,
        layout: "/admin"
      },
      {
        path: "/question-bank/create-question",
        name: "Create Question",
        icon: "fas fa-plus-circle text-purple",
        component: CreateQuestionPage,
        layout: "/admin"
      },
      {
        path: "/question-bank/passages",
        name: "Manage Passages",
        icon: "fas fa-file-alt text-purple",
        component: ManagePassagesPage,
        layout: "/admin"
      },
      {
        path: "/question-bank/ai-generation",
        name: "AI Generation",
        icon: "fas fa-magic text-purple",
        component: AIGenerationPage,
        layout: "/admin"
      },
      {
        path: "/question-bank/bulk-upload",
        name: "Bulk Upload",
        icon: "fas fa-file-upload text-purple",
        component: BulkUploadPage,
        layout: "/admin"
      },
      {
        path: "/question-bank/feedback",
        name: "Feedback",
        icon: "fas fa-comment-alt text-purple",
        component: FeedbackPage,
        layout: "/admin"
      },
      {
        path: "/question-bank/full-length-exams",
        name: "Full-Length Exams",
        icon: "fas fa-file-alt text-purple",
        component: ManageFullLengthExamsPage,
        layout: "/admin"
      },
      {
        path: "/question-bank/full-length-exam-analytics",
        name: "Exam Analytics",
        icon: "fas fa-chart-bar text-purple",
        component: FullLengthExamAnalyticsPage,
        layout: "/admin"
      }
    ]
  }

  // {
  //   path: "/register",
  //   name: "Register",
  //   icon: "ni ni-circle-08 text-pink",
  //   component: Register,
  //   layout: "/auth"
  // }
];
export default routes;
